import SortBySelect from '@op/components/FilterBoxCommon/filters/single-select-factory';
import useLanguage from '@op/hooks/useLanguage';
import React from 'react';
import "./index.scss";

export default function WeeklyReportDateSelect({
  defaultValue,
  onChange,
  options,
}: {
  defaultValue: any;
  onChange: any;
  options: any;
}) {
  const { formatMessage } = useLanguage();
  return (
    <SortBySelect
      defaultValue={defaultValue}
      onChange={(key: string, value: any) => {
        onChange(value);
      }}
      defaultParams={{
        options,
        className: "weekly-report-date-select-wrapper",
        needFormatMessage: false,
        btnTextPrefix: formatMessage('Week'),
        dealwithButton: (value: string | number, { textMap }: any) =>
          textMap?.[value] || value,
        matchButtonWidth: true,
        style: { marginRight: 10 },
      }}
    />
  );
}
